require('./bootstrap');

// require('alpinejs');

require('datatables.net-bs5');

require('block-ui');

require('sumoselect');

require('tokenize2');

import Sortable from 'sortablejs';
window.Sortable = Sortable;

import Chart from 'chart.js/auto';
window.Chart = Chart;

// import tempusDominus from '@eonasdan/tempus-dominus';
// import customDateFormat from '@eonasdan/tempus-dominus/dist/plugins/customDateFormat'
// tempusDominus.extend(customDateFormat);
// window.tempusDominus = tempusDominus;

import { TempusDominus, extend, DateTime, Namespace } from '@eonasdan/tempus-dominus';
window.tempusDominus = {
    TempusDominus,
    extend,
    DateTime,
    Namespace
};
import customDateFormat from '@eonasdan/tempus-dominus/dist/plugins/customDateFormat'
tempusDominus.extend(customDateFormat);

import { createPopper } from "@popperjs/core";
window.Popper.createPopper = createPopper;


import Tags from "./plugins/tags.js";
window.Tags = Tags;

import GLightbox from 'glightbox';
window.GLightbox = GLightbox;

require('bootstrap-star-rating');

require('jquery.scrollto');

require('jquery.localscroll');

require('select2');

import Shuffle from 'shufflejs';
window.Shuffle = Shuffle;

window.validURL = function (str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
};
window.is_Numeric = function (num) {
    return !isNaN(parseFloat(num)) && isFinite(num);
}

$.when($.ready).then(function () {
    $('[data-bs-toggle="tooltip"]').tooltip();
    $.blockUI.defaults.message = '<div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div>';
    $.blockUI.defaults.css.border = '';
    $.blockUI.defaults.css.backgroundColor = 'transparent';

    PluginInit.sumo();

    $(".toast").toast();

    $('body').on('click', '.print-block-button', function (evt) {
        var target = $(this).data('target');
        $(target).print();
        evt.preventDefault();
    });

    $('body').on('click', '.show-search', function () {
        $('#search-form').find('.search-query')[0].focus();
    });

    $('body').on('click', '.clear-field-button', function () {
        $(this).siblings('.form-control').val('');
    });

    $('body').on('click', '.close-window-button', function (evt) {
        window.close();
        evt.preventDefault();
    });

    // $('.time-control').on('show.td',function(evt){
    //     var $a = $('<a class="toggleMeridiem btn btn-primary" href="#">AM</a>').on('click',function(){
    //         console.log("TEST");
    //     });
    //     $('.tempus-dominus-widget.show:visible button.toggleMeridiem').hide();
    //     $('.tempus-dominus-widget.show:visible').each(function(idx,el){
    //         if ($(el).find('a.toggleMeridiem').length == 0){
    //             $(el).find('button.toggleMeridiem').after($a);
    //         }
    //     })
    // });

    // $('.time-control').on('hide.td',function(evt){
    //     $('.tempus-dominus-widget.show .toggleMeridiem').hide();
    // });

});
